import { Injectable } from '@angular/core';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';
import { BLOCKED_ACCOUNT_PAGE, FeatureToggleEnum } from '~shared/constants';
import { Router, RoutesRecognized } from '@angular/router';
import { AccountInfoContext } from '~shared/constants/account-info.constant';
import { filter, pairwise, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BlockRedirectionService {

  previousUrl: string;

  constructor(private featureFlag: ActiveFeaturesConfigcatService, private router: Router) {
    this.router.events
      .pipe(
        filter(e => e instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((event: any[]) => {
        this.previousUrl = event[0].urlAfterRedirects;
      });
  }

  redirect(blocked?: boolean, obliged?: boolean, context?) {
    this.featureFlag.isFeatureEnabledReadyForCurrentCountry$(FeatureToggleEnum.FF_ENABLE_ITALY_SPLIT_PAYMENT)
      .pipe(take(1))
      .subscribe(
        (enabled: boolean) => {
          if (enabled) {
            this.redirectIfItalySplitPaymentEnabled(blocked, obliged, context);
          } else {
            this.redirectIfItalySplitPaymentDisabled(blocked);
          }
        }
      );
  }

  private redirectIfItalySplitPaymentDisabled(blocked?: boolean) {
    if (blocked) {
      this.router.navigateByUrl(BLOCKED_ACCOUNT_PAGE);
    }
  }

  private redirectIfItalySplitPaymentEnabled(blocked?: boolean, obliged?: boolean, context?) {
    if (context === AccountInfoContext.personal
      && !blocked
      && !obliged
      && this.router.url.replace('/', '') === BLOCKED_ACCOUNT_PAGE
    ) {
      this.router.navigateByUrl(this.previousUrl);
    }

    if ((context === AccountInfoContext.personal && !blocked) || (!blocked && !obliged)) {
      return;
    }

    if (obliged || blocked) {
      this.router.navigateByUrl(BLOCKED_ACCOUNT_PAGE);
    }
  }
}
